// extracted by mini-css-extract-plugin
module.exports = {"root":"MainLayout_root__3YuFT","header":"MainLayout_header__2JC5F"};